import { Field, Float, InputType, ObjectType } from 'type-graphql'
import { Prop, PropType } from '@typegoose/typegoose'
import { Product } from '../product/Product'
import { RelatedEntity } from '../base/RelatedEntity'
import { BaseEntity } from '../base/BaseEntity'
import { InventoryBySerialNumber } from '../inventorybyserialnumber/InventoryBySerialNumber'

@ObjectType()
@InputType('AdjustmentItemInput')
export class AdjustmentItem extends BaseEntity {
  @Field(() => Product)
  @Prop({ type: RelatedEntity })
  product: ReturnType<() => Product>

  /**
   * The number of items to be adjusted
   */
  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  /**
   * Pre-selected inventory serial numbers for products requiring serial numbers.
   * Used during InProgress transition to specify which serial numbers to adjust.
   * Optional - if not provided, FulfillAdjustment will auto-generate/select serial numbers.
   * Stores full InventoryBySerialNumber objects (not just references) to preserve custom codes.
   */
  @Field(() => [InventoryBySerialNumber])
  @Prop({ type: [InventoryBySerialNumber] }, PropType.ARRAY)
  inventoryBySerialNumbers: ReturnType<() => InventoryBySerialNumber[]>
}
